import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const FarmerPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { selectedFarmid, amount } = location.state || {};
  const [bankData, setBankData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedFarmid || !amount) {
      navigate('/dashboard'); // Redirect if no payment info
      return;
    }

    const fetchBankDetails = async () => {
      try {
        const res = await fetch(`https://kmtea.onrender.com/getfarmerdata/${selectedFarmid}`);
        if (!res.ok) throw new Error('Failed to fetch farmer data');
        const data = await res.json();
        setBankData(data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchBankDetails();
  }, [selectedFarmid, amount, navigate]);

  const createOrder = async () => {
    const res = await fetch('https://kmtea.onrender.com/create-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount }),
    });

    if (!res.ok) throw new Error('Failed to create order');
    return await res.json();
  };

  const verifyPayment = async (paymentResponse) => {
    const res = await fetch('https://kmtea.onrender.com/verify-payment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(paymentResponse),
    });
    return await res.json();
  };

  const handleRazorpayPayment = async () => {
    try {
      const order = await createOrder();

      const options = {
        key: 'YOUR_LIVE_KEY_ID', // Replace with your live key ID
        amount: order.amount,
        currency: order.currency,
        name: 'Tea Collection',
        description: 'Farmer Payment',
        order_id: order.id,
        handler: async function (response) {
          // Response contains razorpay_payment_id, razorpay_order_id, razorpay_signature
          const verification = await verifyPayment(response);

          if (verification.status === 'success') {
            alert('Payment successful and verified!');
            // You can update backend DB or UI here
            navigate('/dashboard'); // redirect after success
          } else {
            alert('Payment verification failed!');
          }
        },
        prefill: {
          name: bankData?.name || '',
          email: bankData?.email || 'example@example.com',
          contact: bankData?.phone || '9999999999',
        },
        notes: {
          farmid: selectedFarmid,
        },
        theme: {
          color: '#3399cc',
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      alert('Payment failed: ' + error.message);
    }
  };

  if (!selectedFarmid || !amount) return <p>No payment data. Redirecting...</p>;
  if (loading) return <p>Loading farmer bank details...</p>;
  if (!bankData) return <p>Failed to load farmer data.</p>;

  return (
    <div style={{ padding: '20px' }}>
      <h3>Farmer Bank Details</h3>
      <p><strong>Name:</strong> {bankData.name}</p>
      <p><strong>Bank:</strong> {bankData.bankName}</p>
      <p><strong>Account No:</strong> {bankData.accountNumber}</p>
      <p><strong>IFSC:</strong> {bankData.ifsc}</p>
      <p><strong>Amount to Pay:</strong> ₹{amount}</p>
      <button onClick={handleRazorpayPayment} style={{ marginTop: '20px' }}>
        Pay with Razorpay
      </button>
    </div>
  );
};

export default FarmerPayment;
